import {
  FaHome,
  FaBox,
  FaCog,
  FaClipboard,
  FaUsers,
  FaFileAlt,
  FaHeadset,
  FaBoxOpen,
  FaClipboardList,
  FaStore,
  FaRegFileAlt,
  FaSignOutAlt,
  FaChevronDown,
  FaChevronRight,
  FaShoppingCart,
  FaListUl,
  FaListAlt,
  FaTractor,
  FaDashcube,
  FaSalesforce,
  FaSellcast,
} from "react-icons/fa";
import { IoIosClose } from "react-icons/io";
import { HiOutlinePencilAlt } from "react-icons/hi";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../components/Image/kiyo_logo.png";
import React, { useState, useEffect, useMemo } from "react";

const AdminSidebar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeRoute, setActiveRoute] = useState(location.pathname);
  const [openMenus, setOpenMenus] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const userRole = localStorage.getItem("role");

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setActiveRoute(location.pathname);
    menuItems.forEach((item) => {
      if (item.children) {
        const isActiveChild = item.children.some(
          (child) => child.route === location.pathname
        );
        if (isActiveChild) {
          setOpenMenus((prev) => ({ ...prev, [item.tMenuName]: true }));
        }
      }
    });
  }, [location.pathname]);

  const toggleMenu = (menu) => {
    setOpenMenus((prev) => {
      const newOpenMenus = { ...prev, [menu]: !prev[menu] };
      Object.keys(newOpenMenus).forEach((key) => {
        if (key !== menu) newOpenMenus[key] = false;
      });
      return newOpenMenus;
    });
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/login");
  };

  const handleNavigate = (route, isChildRoute = false) => {
    if (isMobile) {
      toggleSidebar();
    }
    setActiveRoute(route);
    if (!isChildRoute) {
      setOpenMenus({});
    }
    navigate(route);
  };

  const menuItems = useMemo(
    () =>
      [
        ...(userRole !== "finance"
          ? [
              {
                title: "Dashboard",
                icon: <FaDashcube size={16} />,
                route: "/admin/dashboard",
                tMenuName: "dashboard",
              },
              {
                title: "Orders",
                icon: <FaListUl size={16} />,
                tMenuName: "orders",
                children: [
                  {
                    title: "New Orders",
                    icon: <HiOutlinePencilAlt size={16} />,
                    route: "/admin/order",
                  },
                  {
                    title: "Manage Orders",
                    icon: <FaClipboard size={16} />,
                    route: "/admin/order/status-details",
                  },
                ],
              },
              {
                title: "Purchase",
                icon: <FaBoxOpen size={16} />,
                tMenuName: "purchase",
                children: [
                  {
                    title: "Purchase Orders",
                    icon: <FaClipboardList size={16} />,
                    route: "/admin/purchaseOrder",
                  },
                  {
                    title: "Order Details",
                    icon: <FaFileAlt size={16} />,
                    route: "/admin/purchaseOrder-details",
                  },
                  {
                    title: "Local Orders",
                    icon: <FaStore size={16} />,
                    route: "/admin/purchaseOrder/localpurchaseorder",
                  },
                ],
              },
              {
                title: "Users",
                icon: <FaUsers size={16} />,
                tMenuName: "user",
                children: [
                  {
                    title: "Total Users",
                    icon: <FaUsers size={16} />,
                    route: "/admin/users",
                  },
                  {
                    title: "Clients",
                    icon: <FaUsers size={16} />,
                    route: "/admin/clients",
                  },
                  {
                    title: "Supplier",
                    icon: <FaUsers size={16} />,
                    route: "/admin/supplier",
                  },
                ],
              },
              {
                title: "Items Master",
                icon: <FaListAlt size={16} />,
                route: "/admin/items-master",
                tMenuName: "items-master",
              },
              {
                title: "Client Payments",
                icon: <FaRegFileAlt size={16} />,
                route: "/admin/client/payment/details",
                tMenuName: "client-payments",
              },
              {
                title: "All Client Payments",
                icon: <FaRegFileAlt size={16} />,
                route: "/admin/client/payment",
                tMenuName: "all-client-payments",
              },
              {
                title: "Inventory",
                icon: <FaBox size={16} />,
                tMenuName: "inventory",
                children: [
                  {
                    title: "Item Inventory",
                    icon: <FaBox size={16} />,
                    route: "/admin/warehouse-inventory",
                  },
                  {
                    title: "Transfer History",
                    icon: <FaTractor size={16} />,
                    route: "/admin/warehouse-inventory/transferhistory",
                  },
                ],
              },
              {
                title: "Reports",
                icon: <FaFileAlt size={16} />,
                tMenuName: "reports",
                children: [
                  {
                    title: "Sales Exec. Report",
                    icon: <FaFileAlt size={16} />,
                    route: "/admin/sales-executive/report",
                  },
                  {
                    title: "Sales Report",
                    icon: <FaSellcast size={16} />,
                    route: "/admin/sales-report",
                  },
                ],
                showIfRole: (role) =>
                  role !== "sales executive" &&
                  role !== "finance" &&
                  role !== "client",
              },
            ]
          : []),
        ...(userRole === "finance"
          ? [
              {
                title: "Client Payments",
                icon: <FaRegFileAlt size={16} />,
                route: "/finance/client/payment/details",
                tMenuName: "finance-client-payments",
              },
            ]
          : []),
        {
          title: "Logout",
          icon: <FaSignOutAlt size={18} />,
          onClick: handleLogout,
          tMenuName: "logout",
        },
      ].filter((item) => !item.showIfRole || item.showIfRole(userRole)),
    [userRole]
  );

  return (
    <aside
      className={`fixed top-0 left-0 z-50 h-full bg-gray-100 shadow-lg transform transition-all duration-300 ease-in-out ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      } min-w-52 overflow-y-auto`}
      style={{ scrollbarWidth: "none" }}
    >
      <div className="flex items-center justify-between sm:justify-center px-2 pt-2">
        <img
          src={logo}
          alt="Kiyo International"
          className="h-8 sm:h-16 object-contain"
        />
        <button
          className="text-gray-600 hover:text-red-600 transition-transform duration-300 sm:hidden"
          onClick={toggleSidebar}
          aria-label="Toggle Sidebar"
        >
          <IoIosClose size={24} />
        </button>
      </div>

      <nav className="p-2">
        <ul className="space-y-1">
          {menuItems.map((item) => (
            <li key={item.tMenuName}>
              <button
                onClick={() =>
                  item.children
                    ? toggleMenu(item.tMenuName)
                    : item.onClick
                    ? item.onClick()
                    : handleNavigate(item.route, false)
                }
                className={`w-full grid grid-cols-[min-content_max-content_1fr] cursor-pointer items-center gap-3 p-2 text-sm font-medium transition-all rounded-md duration-200 hover:bg-gray-200 ${
                  activeRoute === item.route
                    ? "bg-gray-200 text-gray-900"
                    : "text-gray-700 hover:text-gray-900"
                } ${
                  item.title === "Logout"
                    ? "bg-[#d60033] text-white mt-4 hover:bg-red-700"
                    : ""
                }`}
                title={item.title}
              >
                <span
                  className={`text-lg ${
                    item.title === "Logout" ? "text-white" : "text-[#D60033]"
                  } truncate`}
                >
                  {item.icon}
                </span>
                <span className="truncate">{item.title}</span>
                {item.children &&
                  (openMenus[item.tMenuName] ? (
                    <FaChevronDown size={12} />
                  ) : (
                    <FaChevronRight size={12} />
                  ))}
              </button>
              {item.children && (
                <div
                  className={`overflow-hidden transition-[max-height] duration-300 ease-in-out ${
                    openMenus[item.tMenuName] ? "max-h-96" : "max-h-0"
                  }`}
                >
                  <ul className="pl-6 space-y-1">
                    {item.children.map((child, i) => (
                      <li key={child.route}>
                        <button
                          onClick={() => handleNavigate(child.route, true)}
                          className={`${
                            i === 0 ? "mt-2" : ""
                          } w-full flex items-center gap-3 p-2 cursor-pointer text-sm font-medium rounded-md transition-all duration-200 hover:bg-gray-200 ${
                            activeRoute === child.route
                              ? "bg-gray-200 text-gray-900"
                              : "text-gray-700 hover:text-gray-900"
                          }`}
                          title={child.title}
                        >
                          <span className="text-lg text-[#D60033]">
                            {child.icon}
                          </span>
                          <span className="truncate">{child.title}</span>
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default AdminSidebar;
